<div class="confirmation">
  <h2 mat-dialog-title><mat-icon color="warn" class="d-table">warning</mat-icon>{{ dialogData.title }}</h2>
  <p>{{ dialogData.displayText }}</p>
  @if (!!dialogData.additionalDisplayText) {
  <p class="pb-2">{{ dialogData.additionalDisplayText }}</p>
  }
  <div>
    @if (dialogData.isConfirmed) {
    <form [formGroup]="confirmationForm">
      <mat-form-field>
        <mat-label>{{ dialogData.inputPlaceholder }}</mat-label>
        <input matInput type="text" formControlName="comment">
        @if (hasErrorOfType('comment', 'required') || hasErrorOfType('comment', 'maxlength')
        || hasErrorOfType('comment', 'minlength')) {
        <mat-error>
          {{ dialogData.validationMessage }}
        </mat-error>
        }
      </mat-form-field>
    </form>
    }
    <div class="btn-group justify-content-end" role="group">
      @if (dialogData.isConfirmed) {
      <button mat-button mat-dialog-close>{{dialogData.cancelBtnName ? dialogData.cancelBtnName : 'Cancel' }}</button>
      <button mat-button [disabled]="confirmationForm.invalid"
        [mat-dialog-close]="confirmationForm.invalid ? '' : commentCtrl.value">
        {{ dialogData.confirmBtnName ? dialogData.confirmBtnName : 'Confirm' }}</button>
      } @else {
      <button mat-button mat-dialog-close>No</button>
      <button mat-button (click)="onConfirm()">Yes</button>
      }
    </div>
  </div>
</div>